import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import { metronic } from "../../_metronic";
import { servicesReducer } from "./ducks/services.duck";
import { documentReducer } from "../pages/admin/pages/Lawsuit/utils/handleStatusDocument";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  services: servicesReducer,
  document: documentReducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
